import React from "react";



export default function ActiveStudents() {
    return (
        <div>
            <h4><b>Batch Change</b></h4>
        </div>
    )
}
